import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import { useFlexibleTranslation } from '../contexts/LanguageContext';

const DialogOverlay = styled.div`
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 2000;
`;

const DialogContent = styled.div`
  background: white; border-radius: 12px; padding: 24px;
  width: 500px; max-width: 90vw; max-height: 85vh;
  overflow-y: auto; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

const DialogHeader = styled.div`
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 24px;
`;

const DialogTitle = styled.h2`margin: 0; color: #333; font-size: 20px;`;

const CloseButton = styled.button`
  background: none; border: none; font-size: 24px; cursor: pointer;
  color: #666; padding: 4px;
  &:hover { color: #333; }
`;

const Section = styled.section`
  margin-bottom: 24px;
  &:last-child { margin-bottom: 0; }
`;

const SectionTitle = styled.h3`color: #444; font-size: 16px; margin: 0 0 16px 0;`;

const FormGroup = styled.div`margin-bottom: 16px;`;

const Label = styled.label`
  display: block; margin-bottom: 6px; font-size: 14px;
  font-weight: 500; color: #2d3748;
`;

const ReadOnlyField = styled.div`
  padding: 10px 12px; background-color: #f8f9fa;
  border: 1px solid #e0e0e0; border-radius: 6px;
  font-size: 14px; color: #6c757d;
`;

const EditProfileDialog = ({ isOpen, onClose, user, companyName }) => {
  const { t } = useFlexibleTranslation();

  if (!isOpen) return null;

  const notProvided = t('editProfile.notProvided', 'Not provided');

  return (
    <DialogOverlay onClick={onClose}>
      <DialogContent onClick={e => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>{t('editProfile.accountDetails', 'Account Details')}</DialogTitle>
          <CloseButton onClick={onClose}>&times;</CloseButton>
        </DialogHeader>

        <Section>
          <SectionTitle>{t('editProfile.accountInformation', 'Account Information')}</SectionTitle>
          <FormGroup>
            <Label>{t('editProfile.name', 'Name')}</Label>
            <ReadOnlyField>{user?.profile?.name || notProvided}</ReadOnlyField>
          </FormGroup>
          <FormGroup>
            <Label>{t('editProfile.email', 'Email')}</Label>
            <ReadOnlyField>{user?.profile?.email || notProvided}</ReadOnlyField>
          </FormGroup>
          <FormGroup>
            <Label>{t('editProfile.company', 'Company')}</Label>
            <ReadOnlyField>{companyName || notProvided}</ReadOnlyField>
          </FormGroup>
        </Section>

        <Section style={{ textAlign: 'right' }}>
          <Button onClick={onClose}>{t('common.close', 'Close')}</Button>
        </Section>
      </DialogContent>
    </DialogOverlay>
  );
};

export default EditProfileDialog;